import PropTypes from "prop-types";
import React from "react";
import { Button } from "react-bootstrap";
import styled from "styled-components";

const Pagination = (props) => {
  const { currentPage, pages, onChangePage } = props;
  return (
    <Container>
      {Array.from(Array(pages).keys()).map((pageIndex) => {
        const page = pageIndex + 1;
        return (
          <ButtonCircle
            onClick={() => onChangePage(page)}
            key={page}
            variant={page === currentPage ? "primary" : "default"}
          >
            <TextButton> {page}</TextButton>
          </ButtonCircle>
        );
      })}
    </Container>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
};

Pagination.defaultProps = {};

export default Pagination;

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 30px;
  flex: 1;
  margin-bottom: 15px;
  justify-content: center;
`;

const ButtonCircle = styled(Button)`
  border-radius: 20px;
`;

const TextButton = styled.p`
  margin-top: -5px;
`;
